import { useFormContext } from 'react-hook-form'
import { useMethods } from '@shared/hooks/methods'

import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import RemoveIcon from '@mui/icons-material/Remove'
import Tooltip from '@mui/material/Tooltip'

export default function Attachments({attachments}) {
    const {
        setValue,
        getValues
    } = useFormContext()
    const { showMessage } = useMethods()

    const deleteItem = id => {
        const prev = getValues('attachments')
        const index = prev.findIndex(i => i.id === id)
        const removedItem = prev[index]

        setValue(
            'attachments',
            prev.filter(i => i.id !== id)
        )

        let undone = false
        const timeoutId = setTimeout(() => {
            if (!undone) URL.revokeObjectURL(removedItem.url)
        }, 6000)

        showMessage({
            text: 'تم الحذف',
            action: {
                text: 'تراجع',
                onClick: () => {
                    undone = true
                    clearTimeout(timeoutId)
                    const current = getValues('attachments')
                    const restored = [...current]
                    restored.splice(index, 0, removedItem)
                    setValue('attachments', restored)
                    showMessage(null)
                }
            }
        })
    }

    return attachments.map((attachment, i) => (
        <Box
            key={attachment.id}
            sx={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                gap: 2
            }}
        >
            <Typography>{i+1}</Typography>
            <Link
                target='_blank'
                href={attachment?.url || attachment.file}
                sx={{width: '100%'}}
            >
                {attachment?.name || attachment.file.split('/').slice(-1)}
            </Link>
            <Tooltip title='حذف'>
                <IconButton onClick={() => deleteItem(attachment.id)}>
                    <RemoveIcon />
                </IconButton>
            </Tooltip>
        </Box>
    ))
}